import React, { useRef, useState } from 'react';
import { TextField, Box, Grid } from '@material-ui/core';

export default function OtpInput({ length = 6, onChange }) {
    const [values, setValues] = useState(Array(length).fill(''));
    const inputsRef = useRef([]);

    const handleChange = (e, index) => {
        const val = e.target.value.replace(/[^0-9]/g, ''); // allow only number

        const newValues = [...values];
        newValues[index] = val;
        setValues(newValues);

        // move to next input automatically
        if (val && index < length - 1) {
            inputsRef.current[index + 1].focus();
        }

        onChange?.(newValues.join(''));
    };

    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace' && !values[index] && index > 0) {
            inputsRef.current[index - 1].focus();
        }
    };

    return (
        <Grid container justifyContent="center" spacing={1}>
            {values.map((value, index) => (
                <Grid item key={index} xs={2}>
                    <TextField
                        key={index}
                        variant="outlined"
                        inputProps={{
                            maxLength: 1,
                            style: { textAlign: 'center', fontSize: 20, width: '10', height: 10 }
                        }}
                        value={value}
                        onChange={(e) => handleChange(e, index)}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                        inputRef={(el) => (inputsRef.current[index] = el)}
                    />
                </Grid>
            ))}
        </Grid>
    );
}
